import React from "react"
import './src/styles/global.css';

import {ProvideAuth} from "./src/contexts/authContext";
export const wrapRootElement = ({element}) => (
    <ProvideAuth>{element}</ProvideAuth>
)